import { CustomTypeEnum } from '@semanticedge/persistence-service-noheaders-client/src'
import type { LeverValueType } from '../types/lever.js'

export const LIST_VALUE_TYPES: ReadonlySet<LeverValueType> = new Set([
	CustomTypeEnum.IntegerList,
	CustomTypeEnum.FloatList,
	CustomTypeEnum.StringList,
	CustomTypeEnum.BooleanList,
	CustomTypeEnum.CdtList
])

export const INTEGER_PATTERN = /^-?\d+$/
